<template>
  <div class="line">
    <span class="title">{{title}}正答率的趋势</span>
    <div ref="chart" class="line-chart"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'evaluationLine',
  props: {
    title: {
      default: '测评',
    },
    accuaryTrend: {
      default: () => [],
      type: Array,
    },
    classId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      subjectId: 0,
      dataList: [],
      evaluateId: '',
      schoolId: '',
      batchId: '',
      type: '',
    };
  },
  watch: {
    accuaryTrend: {
      immediate: true,
      handler() {
        setTimeout(() => {
          this.init();
        }, 500);
      },
    },
  },
  methods: {
    init() { // 折线图渲染
      this.dataList = this.accuaryTrend;
      this.chart = this.$echarts.init(this.$refs.chart);
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          position(point) {
            // 固定在顶部
            return [point[0], '10%'];
          },
          enterable: true, // 鼠标可以进入
          // triggerOn: 'click',
          formatter: (params) => {
            const title = params[0].axisValue;
            const testName = this.dataList[params[0].dataIndex].evaluate_name;
            const rightNum = this.dataList[params[0].dataIndex].right_num;
            const avgAccuary = this.dataList[params[0].dataIndex].avg_accuary;
            const myAccuary = this.dataList[params[0].dataIndex].my_accuary;
            this.evaluateId = this.dataList[params[0].dataIndex].evaluate_id;
            this.schoolId = this.dataList[params[0].dataIndex].school_id;
            this.batchId = this.dataList[params[0].dataIndex].batch_id;
            this.type = this.dataList[params[0].dataIndex].type;
            let htmlStr = '<div>';
            htmlStr += `<div>${title} 发布</div><br/>`;
            htmlStr += `<div>《${testName}》</div><br/>`;
            htmlStr += `<div>答题数: ${rightNum}</div><br/>`;
            htmlStr += `<div>班级平均正答率: ${avgAccuary}%</div><br/>`;
            htmlStr += `<div>我的正答率: ${myAccuary}%</div><br/>`;
            htmlStr += '</div>';
            return htmlStr;
          },
        },
        grid: {
          left: '0',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
        },
        legend: {
          data: [{
            name: '我的正答率',
            icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIqADAAQAAAABAAAAIAAAAAB4uvI0AAAEYElEQVRYCcVXW2hcVRRd5840Jo1N60ex8yAFUQOCKaYRBfthsZ8FP2pKVCwtVFpi0tQfMYKWakULfiTj1HaURqwgNOmXICjFx4eCIgWNWGqQ1kemU1GsfcQkbeZu174z5+bOK73TOno+cvbeZz/WWXefcybAfzCSY9JyrTLOtRz+jfX5HPYn03LfYrkaDqTjsCyDYGs+j8yDn0q0FpiGA7l0GVtYfJkI1kx+h6f/NyAC9Nniros9sbSstnpwbigjiRFZTybuChRslTzSAd0XGwrEBZ7yK1lBsDE2LJusaueGAUkelATZeNgWMgYfWpnziNfEAUPDgLhXsIN17Cn5pKUZvTA4p7XZN4mLl7AvgAOLAlmdkZiImGBAGHltRpbwszxpfY2DA6d3mAuOg93WRjD9sRFZa/VFgczNYiiZQo91DjvnZrGJ216l/txFtuNuvK/y2QFzlPpHKnM49HmzZ0wiBcWzVf7Ra9kInuDO9i12EVVGetQvNKmDQ5+tN/PWb0kT+ghmRnWy0vV5Dv0q12TEzaGXjivYcHf8MIHt6hxmJIelkzHrPF+Dq80u3grG/dJnTpOml4q2eX745SrXBiJes3n+TPxCPCNLi8GLTnmzcGTJ6LEzu81v5QHxZrzmGLwTjaDr3C7zoq5XbcREStbkXXwTTMDj91xu0LwStJXLt2Vk+d8zyNLeqmtOBOvYF1+U+1XTqzJCBvTolQ7BM+1vyC2lxlJtZhZbafFAEPi3YUFolgognUeklQ36uC7qIGV/6qz9cuUqnlW52igec/9dYeCBan61bBVA/jiPR1m1TQO4q1PiLLDDbz6gN2a1ZIkRbCCTd3prBhdWrsB71fxq2SqAlHwWgwyb6RgBfa0JyEpLfg57qiVj9/tHloDfnthipqv51bKVAImnpYvFutWZxWcjS3FEZToN6ayD69sSaSnsvGBCfETaad/oqQbiRHGwuBR6KgHCJzrYpONT243XH9lB8zGBHS9mjbp5vBysQBA7idC7IdlTx7P9ZjK4Hkb2gehryISP2SC+DxkrF+chNiBdyIrgkdjr4jF3e0puosm/8PRdKfrXNflALk4ThODmYvT35UePd8gJro3b7OLiVZWnXfQQ2EqVydrPD9yKD1Sud/hACML/LLz1ytnw8kYieJ5C4d0QPBRPyYaSJgUOjW82+XpBqL8HZNWw3Mtd3aMGfZCa2vCuyuVDvz13PWrtjDnMDdyvOu1zrqF+ncMDwiQ+G2yCoz9tM3/Vyhd1sFfB6jqBtAf8xnjUfw/odYkOm62NCXttVKSySe2SN/86YM4SbKrESIWf7bqa1OZxLgNJMnLKMxhMZHeZL+1irbmpCfvJis8a409M9ZuvavmHsTuk8yRPRDeTdZP2wTBB/E1xnsfUOzXqT1A3xEYxR5jSlT76C47/0/7I67w5EkdyarPx+qbSM5xl4fiG8/e9tDCZ2EsmR28UhCa1P/f9AvUIHZ0YPTNZuMzqiavm+w+Gm06BJkbpagAAAABJRU5ErkJggg==',
          }],
          left: '85%',
          itemWidth: 12,
          itemHeight: 12,
        },
        xAxis: {
          type: 'category',
          name: '发布时间',
          data: this.dataList.map((item) => `${dayjs(item.date * 1000).month() + 1}月${dayjs(item.date * 1000).date()}日`),
          axisLine: { // 不显示轴线
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          name: '正答率',
          nameTextStyle: { // name样式修改
            align: 'center',
            color: '#C5C3DE',
            padding: [0, 0, 12, -18],
          },
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed', // 设置网格线类型 dotted：虚线 solid:实线
              width: 1,
            },
            show: true, // 隐藏或显示
          },
          min: 0,
          max: 100,
        },
        series: [{
          name: '我的正答率',
          symbolSize: 10,
          data: this.dataList.map((item) => item.my_accuary.toFixed()),
          type: 'line',
        }],
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.line {
  margin-bottom: 30px;
  .tooltip{
    width: 16px;
    height: 16px;
    vertical-align:text-bottom;
  }
  .title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
        left: 0;
        bottom: 3px;
      }
   }
  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 42px;
    &__subject {
      display: flex;
      height: 40px;
      font-size: 14px;
      padding: 2px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 40px;
      background: #F0F2F5;
      border-radius: 4px;
      li {
        width: 90px;
        text-align: center;
        &:hover {
          color: #1989FA;
        }
      }
    }
    .isactive {
      background-color: #FFFFFF;
      color: #1989FA;
      border-radius: 2px;
    }
  }
  &-chart {
    height: 440px;
    // width: 100vw;
  }
}

</style>
